<template>
    <div class="admin-locations-page">
        <button-component
                class="new-location-button"
                @click.native="addNewLocation()">
            Woonlocatie toevoegen
        </button-component>
        <ul>
            <listitem-component
                    v-for="location in getAllLocations"
                    :key="location.id"
                    @click.native="editLocation(location)">
                {{ location.locationName }}
            </listitem-component>
            <p v-if="getAllLocations.length < 1">Er zijn nog geen woonlocaties toegevoegd</p>
        </ul>
    </div>
</template>

<script>
import { Viewport } from '../../utils/enums';
import { RouteName } from '../../utils/enums';
import ListitemComponent from '../../components/listitem.component';
import ButtonComponent from '../../components/button.component.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'admin-locations-page',
    components: {
        ListitemComponent,
        ButtonComponent
    },
    computed: {
        ...mapGetters(['getAllLocations']),
    },
    created() {
        this.$store.dispatch('FETCH_ALL_LOCATIONS');
    },
    methods: {
        editLocation(location) {
            this.$store.commit('SET_LOCATION_TO_EDIT', location);
            this.$router.push({ name: RouteName.ADMIN_EDIT_LOCATION });
        },
        addNewLocation() {
            this.$router.push({ name: RouteName.ADMIN_NEW_LOCATION });
        }
    }
};
</script>

<style scoped lang="scss">
    .listitem-component::v-deep {
        .listitem-icon {
            background-image: url('../../assets/icons/building-white.svg');
            background-position-y: 12px;
        }
    }
    .new-location-button {
        margin-bottom: 1rem;
    }
</style>
